import { render, staticRenderFns } from "./card2.vue?vue&type=template&id=79a65925&scoped=true&"
import script from "./card2.vue?vue&type=script&lang=js&"
export * from "./card2.vue?vue&type=script&lang=js&"
import style0 from "./card2.vue?vue&type=style&index=0&id=79a65925&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a65925",
  null
  
)

export default component.exports